import { useEffect, useRef } from 'react';
import type { EffectCallback, DependencyList } from 'react';

const useOnUpdateOnly = (effect: EffectCallback, deps?: DependencyList) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      return effect();
    }
    didMountRef.current = true;
    // Thanks linter, but we're doing the right thing here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return didMountRef.current;
};

export { useOnUpdateOnly };
